import React from 'react';
import InputField from '../../../../../common/InputField';

const BasicDetails = () => {
  return (
    <div className="basic-details-wrapper">
      <h3>Company Details</h3>
      <InputField name={['company', 'orgName']} label={'Company Name'} isDisabled={true} />
      {/* <InputField
                name={['company', 'orgWebsite']}
                label={'Company Website'}
                isDisabled={true}
            /> */}
      {/* <InputField
                name={['company', 'businessRegNo']}
                label={'Business Registration Number'}
                isDisabled={true}
            /> */}
    </div>
  );
};

export default BasicDetails;
